<template>
  <div class="wrap">
    <div class="content">
      <section class="main_title">空气负(氧)离子浓度</section>
      <section class="date">{{ this.time || '' }}</section>
      <section class="main">
        <div class="main-content">
          <section class="first">
            <div class="title">
              <img src="@/assets/image/top_1.png" class="rank" />
              <h4 class="name">{{ anionFirst.name || '' }}</h4>
              <div class="level">
                <img :src="getLevelImg(anionFirst.leave)" />
                <span>{{ anionFirst.leave || '' }}</span>
              </div>
            </div>
            <div class="anion_value">
              <div>
                <span class="number">{{ anionFirst.num || 0 }}</span>
                <span class="text">平均值</span>
              </div>
              <div>
                <span class="number">{{ anionFirst.max || 0 }}</span>
                <span class="text">最大值</span>
              </div>
              <div>
                <span class="number">{{ anionFirst.min || 0 }}</span>
                <span class="text">最小值</span>
              </div>
            </div>
          </section>
          <section class="sed">
            <div v-for="(item, index) in anionSed" :key="item.name">
              <div class="title">
                <img
                  :src="
                    index == 0
                      ? require('@/assets/image/top_2.png')
                      : require('@/assets/image/top_3.png')
                  "
                  class="rank"
                />
                <h4 class="name">{{ item.name || '' }}</h4>
                <div class="level">
                  <img :src="getLevelImg(item.leave)" />
                  <span>{{ item.leave || '' }}</span>
                </div>
              </div>
              <div class="anion_value">
                <div>
                  <span class="number">{{ item.num || '' }}</span>
                  <span class="text">平均值</span>
                </div>
                <div>
                  <span class="number">{{ item.max || '' }}</span>
                  <span class="text">最大值</span>
                </div>
                <div>
                  <span class="number">{{ item.min || '' }}</span>
                  <span class="text">最小值</span>
                </div>
              </div>
            </div>
          </section>
          <section class="last">
            <div v-for="(item, index) in anionLast" :key="item.name">
              <div class="title">
                <span class="rank">{{
                  index >= 6 ? +index + 4 : 0 + index * 1 + 4
                }}</span>
                <h4 class="name">{{ item.name || '' }}</h4>
                <div class="level">
                  <img :src="getLevelImg(item.leave)" />
                  <span>{{ item.leave || '' }}</span>
                </div>
              </div>
              <div class="anion_value">
                <div>
                  <span class="number">{{ item.num || '' }}</span>
                  <span class="text">平均值</span>
                </div>
                <div>
                  <span class="number">{{ item.max || '' }}</span>
                  <span class="text">最大值</span>
                </div>
                <div>
                  <span class="number">{{ item.min || '' }}</span>
                  <span class="text">最小值</span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  components: {},
  data() {
    return {
      apiUrl: 'https://cl.gd-ib.cn/flowers/json/fulizi.json', //api地址
      anionFirst: {}, //离子数据 第一
      anionSed: [], //2  3
      anionLast: [], //4  5
      time: '',
      loading: '',
      anionTipList: [
        {
          level: 'Ⅰ级',
          img: require('@/assets/image/level_1.png')
        },
        {
          level: 'Ⅱ级',
          img: require('@/assets/image/level_2.png')
        },
        {
          level: 'Ⅲ级',
          img: require('@/assets/image/level_3.png')
        },
        {
          level: 'Ⅳ级',
          img: require('@/assets/image/level_4.png')
        }
      ]
    }
  },
  mounted() {
    this.getTime()
    this.getData()
  },
  methods: {
    //获取离子数据
    getData() {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      axios
        .get(this.apiUrl)
        .then(({ data }) => {
          let arr = data.data || []
          this.anionFirst = { ...arr[0] }
          this.anionSed = arr.slice(1, 3)
          this.anionLast = arr.slice(3)
          this.loading.close()
        })
        .catch((e) => {
          this.loading.close()
        })
    },
    //获取时间
    getTime() {
      var req = new XMLHttpRequest()
      req.open('GET', location, false)
      req.send(null)
      let dateTime = new Date(req.getResponseHeader('Date'))
      let year = dateTime.getFullYear()
      let month = String(dateTime.getMonth() + 1).padStart(2, '0')
      let day = String(dateTime.getDate()).padStart(2, '0')
      this.time = year + '年' + month + '月' + day + '日'
    },
    getLevelImg(level) {
      if (!level) return
      let img = this.anionTipList.find((i) => i.level == level).img
      return img
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  width: 2304px;
  height: 2390px;
  // max-height: 2390px;
  background-color: #000;
  box-sizing: border-box;
  overflow: hidden;
  padding: 40px 70px;
}
.content {
  height: 2310px;
  // max-height: 2310px;
  margin: 0 auto;
  background-image: url(~@/assets/image/anionScreen/bg.png);
  background-size: 100% 594px;
  background-repeat: no-repeat;
  background-color: #e5f3e8;
  padding: 50px 30px 0 30px;
  box-sizing: border-box;
  overflow: hidden;
  .date {
    width: 354px;
    height: 68px;
    margin: 0 auto 34px auto;
    background-image: url(~@/assets/image/time.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #fff;
    text-align: center;
    line-height: 70px;
    font-size: 36px;
  }
  .main {
    width: 100%;
    margin: 0 auto;
    border-radius: 22px;
    background: rgba(199, 228, 203, 1);
    padding: 32px;
    box-sizing: border-box;
    .main-content {
      border-radius: 22px;
      background: rgba(255, 255, 255, 1);
      padding: 50px 50px 0 50px;
      .first {
        margin-bottom: 50px;
        .title {
          position: relative;
          height: 88px;
          background: linear-gradient(
            90deg,
            rgba(255, 197, 45, 0.6) 0%,
            rgba(255, 230, 163, 0.44) 79.86%,
            rgba(255, 255, 255, 0) 100%
          );
          .rank {
            position: absolute;
            left: -8px;
            top: -8px;
            width: 176px;
            height: 190px;
          }
          .name {
            font-size: 60px;
            line-height: 88px;
            color: rgba(34, 34, 34, 1);
            font-weight: 700;
          }
        }
        .anion_value > div {
          padding-top: 16px;
        }
      }
      .sed {
        display: flex;
        margin-bottom: 40px;
        > div {
          width: 46%;
          &:first-child {
            margin-right: 8%;
            // margin-left: 8%;
            .title {
              background: linear-gradient(
                90deg,
                rgba(255, 182, 171, 1) 0%,
                rgba(255, 182, 171, 0.5) 45.79%,
                rgba(255, 255, 255, 0) 100%
              );
            }
          }
          .title {
            position: relative;
            padding-left: 0;
            background: linear-gradient(
              90deg,
              rgba(242, 188, 141, 1) 0%,
              rgba(242, 188, 141, 0.5) 50.65%,
              rgba(255, 255, 255, 0) 100%
            );
            .rank {
              position: absolute;
              left: -8px;
              top: -8px;
              width: 108px;
              height: 116px;
            }
            .name {
              flex: 1;
              height: 54px;
              margin-left: 80px;
              padding-left: 20px;
              line-height: 54px;

              font-size: 40px;
              color: rgba(34, 34, 34, 1);
            }
            .level {
              margin-top: 2px;
            }
          }
          .anion_value {
            height: 230px;
            border-radius: 12px;
            background: linear-gradient(
              132.77deg,
              rgba(255, 221, 217, 0.4) 0%,
              rgba(255, 197, 189, 0) 100%
            );
            border: 2px solid rgba(255, 182, 171, 0.5);
            backdrop-filter: blur(6px);
            .number {
              font-size: 80px;
            }
            .text {
              font-size: 40px;
            }
          }
        }
      }
      .last {
        display: flex;
        flex-wrap: wrap;
        > div {
          width: 46%;
          flex-shrink: 0;
          margin-bottom: 30px;
          &:nth-child(2n-1) {
            margin-right: 8%;
          }
        }
        .title {
          position: relative;
          height: 60px;
          background: linear-gradient(
            90deg,
            rgba(195, 232, 200, 1) 0%,
            rgba(195, 232, 200, 1) 68.23%,
            rgba(255, 255, 255, 0) 100%
          );
          padding-left: 24px;
          margin-bottom: 20px;
          margin-left: 46px;
          .rank {
            position: absolute;
            top: 8px;
            left: -40px;
            width: 52px;
            height: 44px;
            background: rgba(170, 204, 174, 1);
            text-align: center;
            line-height: 44px;
            color: #fff;
            font-size: 36px;
          }
          .name {
            font-size: 40px;
            color: rgba(34, 34, 34, 1);
          }
        }
        .anion_value {
          height: 156px;
          border-radius: 14px;
          background: rgba(195, 232, 200, 0.1);
          border: 1px solid rgba(195, 232, 200, 1);
          .number {
            font-size: 60px;
          }
          .text {
            font-size: 36px;
            margin-bottom: 12px;
          }
        }
      }
    }
  }
}
.main_title {
  text-align: center;
  color: rgba(31, 172, 107, 1);
  font-size: 74px;
  font-weight: 900;
  // -webkit-text-stroke: 2px #fff;
  // text-stroke: 2px #fff;
  margin-bottom: 30px;
  text-shadow: 2px 2px 8px rgba(255, 255, 255);
}
//公用
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 190px;
  margin-bottom: 48px;
  .level {
    display: flex;
    align-items: center;
    span {
      font-size: 30px;
      font-weight: 700;
    }
    img {
      width: 32px;
      height: 32px;
      margin-right: 10px;
    }
  }
}
.anion_value {
  width: 100%;
  height: 270px;
  display: flex;
  justify-content: space-around;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    rgba(255, 232, 170, 0.4) 0%,
    rgba(255, 243, 209, 0) 100%
  );
  border: 1px solid rgba(255, 177, 45, 1);
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .number {
      font-size: 100px;
      font-weight: 700;
      color: rgba(23, 177, 107, 1);
    }
    .text {
      font-size: 50px;
    }
  }
}
@media screen and (max-width: 750px) {
  .wrap {
    transform: scale(0.2);
    transform-origin: top left;
  }
}
@media screen and (min-width: 751px) and (max-width: 1024px) {
  .wrap {
    transform: scale(0.3);
    transform-origin: top left;
  }
}
@media screen and (min-width: 1025px) and (max-width: 1440px) {
  .wrap {
    transform: scale(0.55);
    transform-origin: top left;
  }
}

@media screen and (min-width: 1441px) and (max-width: 1600px) {
  .wrap {
    transform: scale(0.68);
    transform-origin: top left;
  }
}
@media screen and (min-width: 1601px) and (max-width: 1920px) {
  .wrap {
    transform: scale(0.8);
    transform-origin: top left;
  }
}
</style>
